import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  type LoginConsentForm,
  type LoginConsentId,
} from '../model/use-login-form';

import { LoginConsentItem } from './login-consent-item';

type LoginConsentsProps = {
  consents: LoginConsentForm;
};

const ConsentList = styled.div.attrs({
  'data-ui': 'auth-login-consents',
})`
  width: ${({ theme }) => theme.scale.px(356)};
  align-self: center;
  display: grid;
  gap: ${({ theme }) => theme.scale.px(9)};
`;

const LOGIN_CONSENTS: ReadonlyArray<{
  id: LoginConsentId;
  labelKey: string;
}> = [
  {
    id: 'personalData',
    labelKey: 'login.consentPersonalData',
  },
  {
    id: 'informativeMessages',
    labelKey: 'login.consentInformative',
  },
  {
    id: 'promotionalMessages',
    labelKey: 'login.consentPromotional',
  },
];

export function LoginConsents({ consents }: LoginConsentsProps) {
  const { t } = useTranslation();

  return (
    <ConsentList>
      {LOGIN_CONSENTS.map(({ id, labelKey }) => (
        <LoginConsentItem
          key={id}
          checked={consents.values[id]}
          label={t(labelKey)}
          onChange={next => consents.setValue(id, next)}
        />
      ))}
    </ConsentList>
  );
}
